import EmptyActionPlanImage from 'assets/images/empty-list.svg';
import { Typography } from '@repo/ui';
import { ButtonColors, LinkButton } from 'components/DesignButton/DesignButton';
import styles from './ActionPlan.module.scss';

interface EmptyActionPlanProps {
  hasOtherKitsWithResults?: boolean;
  latestKitDate?: string;
  resultsReadyKitId?: string;
}

const EmptyActionPlan = ({
  hasOtherKitsWithResults = false,
  latestKitDate,
  resultsReadyKitId,
}: EmptyActionPlanProps) => {
  return (
    <div className={styles.emptyActionPlan}>
      <div className='text-center'>
        <img
          src={EmptyActionPlanImage}
          className={styles.emptyActionPlanImage}
        />
      </div>
      {hasOtherKitsWithResults && resultsReadyKitId ? (
        <div className='flex flex-column gap-2'>
          <Typography variant='heading-l' className='m-auto'>
            Your action plan is on its way!
          </Typography>
          <Typography variant='body-s' className='text-center'>
            Your most recent kit{latestKitDate ? ` (${latestKitDate})` : ''} is
            still being processed. While we get everything ready, you can revisit
            your previous action plan.
          </Typography>
          <div className='flex justify-center mt-2'>
            <LinkButton
              href={`/action-plan/${resultsReadyKitId}`}
              label='View previous Action Plan'
              variant='solid'
              size='medium'
              color={ButtonColors.PURPLE}
            />
          </div>
        </div>
      ) : (
        <div className='flex flex-column gap-2'>
          <Typography variant='heading-l' className='m-auto'>
            Nothing to see yet
          </Typography>
          <Typography variant='body-s' className='text-center'>
            You'll get your personalized Action Plan when your lab results are
            ready.
          </Typography>
        </div>
      )}
    </div>
  );
};

export default EmptyActionPlan;
